import React from 'react';
import TaxesListing from '../modules/TaxesListing/TaxesListing';

const TaxesPage = () =>{
  return <TaxesListing/>
}

export default TaxesPage;